import View from './View';
import getStyles from './styles';

export { default as View } from './View';
export const getDefaultStyles = getStyles;

export default View;
